export default __webpack_public_path__ + "static/media/stats.caaa0f18.svg";